/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useMount, useUpdateEffect } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeModal,
  getData,
  openModal,
  configUpdate,
  updateItems,
  robotInit,
} from '../../modules/robot';
import {
  MODAL_TYPE_UPDATE,
  ROBOT_STATUS_HEADER_DATA,
  ROBOT_STATUS_VIEW_LIST_LENGTHS,
} from '../../common/consts';
import RobotTable from '../../components/robot/RobotTable';
import RobotUpdateModal from '../../components/robot/RobotUpdateModal';
import RobotConfigModal from '../../components/robot/RobotConfigModal';
import Toast from '../../components/Toast';
import RobotCallModal from '../../components/call/RobotCallModal';

const RobotStatusContainer = () => {
  const dispatch = useDispatch();
  const { loading, contentItems, total, list, modal } = useSelector(
    (state) => state.robot,
  );
  // const [updateModal, setUpdateModal] = useState(false);
  // const [configModal, setConfigModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    ROBOT_STATUS_VIEW_LIST_LENGTHS[0].value,
  );
  const [order, setOrder] = useState('desc');
  const [sort, setSort] = useState('date');
  const [selected, setSelected] = useState([]);
  const [snack, setSnack] = useState({ open: false });

  const onModalClick = (type, item) => {
    let items = item;
    if (!items) {
      items = selected.map((id) => list.find((li) => li.id === id));
    }
    dispatch(
      openModal({
        items,
        type,
      }),
    );
  };

  const handleAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = list.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleCheckClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);

    const { type, name } = event.target;
    if (type === 'button' && name) {
      onModalClick(name, [list.find((li) => li.id === id)]);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSortClick = (property) => () => {
    const isAsc = sort === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setSort(property);
  };

  const onItemUpdateClick = () => {
    onModalClick(MODAL_TYPE_UPDATE);
  };

  const handleModalCancel = () => {
    setSelected([]);
    dispatch(closeModal());
  };

  const handleModalConfirm = (data) => {
    if (modal.bCon) {
      dispatch(configUpdate(data));
    } else {
      dispatch(updateItems(data));
    }
  };

  const handleInitConfirm = (data) => {
    dispatch(robotInit(data));
  };

  useMount(() => {
    dispatch(
      getData({
        sort,
        desc: order === 'desc',
        skip: 0,
        limit: rowsPerPage,
      }),
    );
  });

  useUpdateEffect(() => {
    dispatch(
      getData({
        sort,
        desc: order === 'desc',
        skip: 0,
        limit: rowsPerPage,
      }),
    );
  }, [sort, order, rowsPerPage]);

  useUpdateEffect(() => {
    dispatch(
      getData({
        sort,
        desc: order === 'desc',
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      }),
    );
  }, [page]);

  useUpdateEffect(() => {
    if (modal.result !== null) {
      const message = modal.result ? modal.message : modal.error;
      const severity = modal.result ? 'success' : 'error';
      setSnack({
        open: true,
        onClose: () => setSnack({ open: false }),
        message,
        severity,
      });

      if (!modal.bCon && modal.result) {
        handleModalCancel();
        dispatch(
          getData({
            sort,
            desc: order === 'desc',
            skip: page * rowsPerPage,
            limit: rowsPerPage,
          }),
        );
      }
    }
  }, [modal.result]);

  return (
    <>
      <RobotTable
        {...{
          title: '로봇 목록',
          name: 'robot_status',
          selectable: true,
          headerItems: ROBOT_STATUS_HEADER_DATA,
          contentItems,
          lengthOptions: ROBOT_STATUS_VIEW_LIST_LENGTHS,
          loading,
          sort,
          total,
          rowsPerPage,
          page,
          order,
          selected,
          onItemUpdateClick,
          handleAllClick,
          handleCheckClick,
          handleChangePage,
          handleChangeRowsPerPage,
          handleSortClick,
        }}
      />
      {'bCon' in modal && modal.bCon === false && !modal.bCall && (
        <RobotUpdateModal
          {...{
            ...modal,
            onCancel: handleModalCancel,
            onUpdate: handleModalConfirm,
          }}
        />
      )}
      {'bCon' in modal && modal.bCon && (
        <RobotConfigModal
          {...{
            ...modal,
            onCancel: handleModalCancel,
            onUpdate: handleModalConfirm,
            onInit: handleInitConfirm,
          }}
        />
      )}
      {modal.bCall && (
        <RobotCallModal
          {...{
            ...modal,
            onCancel: handleModalCancel,
          }}
        />
      )}
      <Toast {...{ ...snack }} />
    </>
  );
};

export default RobotStatusContainer;
